import PropTypes from 'prop-types';
import { Checks, Atom, Flask, Calculator } from '@phosphor-icons/react';
import StatCell from '../generic/StatCell';
import TableHeader from '../../components/generic/TableHeader';
import TableLoader from '../generic/TableLoader';
import { CheckCircleIcon, XCircleIcon, TimerIcon, SmileyXEyesIcon } from '@phosphor-icons/react';
import NoData from '../generic/NoData';

const QualitySummary = ({ data, loading, subjects, onResetFilters }) => {
  if (loading) {
    return (
      <div className="border border-[var(--q3-stroke-light)] rounded-lg p-4">
        <div className="animate-pulse flex space-x-4">
          <div className="flex-1 space-y-4 py-1">
            <div className="h-4 bg-gray-200 rounded w-3/4"></div>
            <div className="space-y-2">
              <div className="h-4 bg-gray-200 rounded"></div>
              <div className="h-4 bg-gray-200 rounded w-5/6"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  console.log('QualitySummary props:', {
    data,
    loading,
    subjects,
    onResetFilters,
  });

  if (!data || data.length === 0) {
    return <NoData onResetAll={onResetFilters} />;
  }
  const getIconForSubject = (subjectId) => {
    switch (subjectId) {
      case 'overall':
        return Checks;
      case '607018ee404ae53194e73d90': // Physics
        return Atom;
      case '607018ee404ae53194e73d91': // Chemistry
        return Flask;
      case '607018ee404ae53194e73d92': // Math
        return Calculator;
      default:
        return CheckCircle;
    }
  };

  console.log('QualitySummary data:', data);

  return (
    <div>
      <TableHeader headerTitle="Summary">
        {/* Added overflow container for horizontal scrolling on mobile */}
        <div className="overflow-x-auto">
          <div className="min-w-[600px] border border-[var(--q3-stroke-light)] rounded-b-lg overflow-hidden">
            {/* Header */}
            <div className="bg-[var(--q3-surface-dim)] border-b border-[var(--q3-stroke-light)]">
              <div className="grid grid-cols-5 divide-x divide-[var(--q3-stroke-light)] text-sm text-[var(--q3-neutral-default)]">
                <div className="p-4">Subject</div>

                <div className="p-4 text-center text-[var(--q3-green-normal)]">
                  <div className="flex items-center justify-center gap-2">
                    <CheckCircleIcon className="w-5 h-5" />
                    <span>Perfect</span>
                  </div>
                </div>

                <div className="p-4 text-center text-[var(--q3-danger-normal)]">
                  <div className="flex items-center justify-center gap-2">
                    <XCircleIcon className="w-5 h-5" />
                    <span>Wasted</span>
                  </div>
                </div>

                <div className="p-4 text-center text-[var(--q3-orange-normal)]">
                  <div className="flex items-center justify-center gap-2">
                    <TimerIcon className="w-5 h-5" />
                    <span>Overtime</span>
                  </div>
                </div>

                <div className="p-4 text-center text-[var(--q3-neutral-light)]">
                  <div className="flex items-center justify-center gap-2">
                    <SmileyXEyesIcon className="w-5 h-5" />
                    <span>Confused</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Data Rows */}
            <TableLoader loading={loading}>
              {data?.length === 0 && <NoData onResetFilters={onResetFilters} />}
              {data.map((subject, index) => {
                const iconUrl = subject?.subjectMeta?.icon;

                return (
                  <div key={index} className="border-b border-[var(--q3-stroke-light)] last:border-b-0">
                    <div className="grid grid-cols-5 divide-x divide-[var(--q3-stroke-light)] text-sm text-[var(--q3-neutral-default)]">
                      {/* Subject with Icon from API */}
                      <div className="p-4 flex items-center gap-2">
                        {iconUrl && (
                          <img
                            src={iconUrl}
                            alt={subject?.subjectMeta?.title || 'Subject Icon'}
                            className="w-5 h-5 object-contain"
                          />
                        )}
                        <span className="font-medium">{subject.subjectMeta.title}</span>
                      </div>

                      {/* Perfect Attempts */}
                      <div className="text-center ">
                        <StatCell
                          color="var(--q3-green-normal)"
                          top={subject.perfectAttempts}
                          bottom={subject.totalQuestions}
                          showPercentage={true}
                          themedText={true}
                        />
                      </div>

                      {/* Wasted Attempts */}
                      <div className="text-center ">
                        <StatCell
                          color="var(--q3-danger-normal)"
                          top={subject.wastedAttempts}
                          bottom={subject.totalQuestions}
                          showPercentage={true}
                          themedText={true}
                        />
                      </div>

                      {/* Overtime Attempts */}
                      <div className="text-center ">
                        <StatCell
                          color="var(--q3-orange-normal)"
                          top={subject.overtimeAttempts}
                          bottom={subject.totalQuestions}
                          showPercentage={true}
                        />
                      </div>

                      {/* Confused Attempts */}
                      <div className="text-center ">
                        <StatCell
                          color="var(--q3-neutral-light)"
                          top={subject.confusedAttempts}
                          bottom={subject.totalQuestions}
                          showPercentage={true}
                          themedText={true}
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
            </TableLoader>
          </div>
        </div>
      </TableHeader>
    </div>
  );
};

export default QualitySummary;
